// Stub for pure-react-carousel, pulled in by @cmpsr/carousel which we never use.
export const CarouselProvider = () => null;
export const ButtonBack = () => null;
export const ButtonNext = () => null;
export const Dot = () => null;
export const DotGroup = () => null;
export const Slide = () => null;
export const Slider = () => null;

const exports: Record<string, unknown> = {
  CarouselProvider,
  ButtonBack,
  ButtonNext,
  Dot,
  DotGroup,
  Slide,
  Slider,
};

const handler: ProxyHandler<Record<string, unknown>> = {
  get(target, prop) {
    if (import.meta.env.DEV && typeof prop === 'string' && prop !== '__esModule' && !(prop in target)) {
      console.error(`[shim] Attempted to use un-shimmed export "${prop}" from "pure-react-carousel". Add it to src/shims/pure-react-carousel-shim.ts.`);
    }
    return target[prop as string];
  },
};

export default new Proxy(exports, handler);
